import { defineStyleConfig } from '@chakra-ui/react';

export const CloseButton = defineStyleConfig({
	baseStyle: {
		bgColor: 'secondary.bgAlpha',
		borderRadius: 'full',
		_hover: {
			bgColor: 'secondary.bgAlphaHover',
		},
		_active: {
			bgColor: 'secondary.bgAlphaActive',
		},
	},
	sizes: {
		sm: {
			boxSize: 6,
		},
		md: {
			boxSize: 8,
		},
		lg: {
			boxSize: 9,
		},
		xl: {
			boxSize: 10,
		},
	},
});
